import { render } from "./LucidProductionView.vue?vue&type=template&id=0193153c&scoped=true"
import script from "./LucidProductionView.vue?vue&type=script&lang=js"
export * from "./LucidProductionView.vue?vue&type=script&lang=js"

import "./LucidProductionView.vue?vue&type=style&index=0&id=0193153c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0193153c"]])

export default __exports__